import { useNavigate } from 'react-router-dom';
import { LogOut, ShieldCheck, User as UserIcon } from 'lucide-react';
import { useAuth } from '../lib/auth';
import { initials } from '../lib/utils';

export default function Profile() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="max-w-2xl space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-slate-900">Profile</h1>
        <p className="text-slate-500 mt-1">Account and preferences.</p>
      </div>

      <div className="card p-6">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-2xl bg-brand-100 grid place-items-center text-brand-700 font-bold text-2xl">
            {initials(user?.full_name || user?.username)}
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-xl font-bold text-slate-900">
              {user?.full_name || user?.username}
            </div>
            <div className="flex items-center gap-2 mt-1">
              <span className="text-sm text-slate-500">@{user?.username}</span>
              {isAdmin && (
                <span className="chip bg-brand-100 text-brand-700 ring-1 ring-inset ring-brand-200">
                  <ShieldCheck className="h-3 w-3" /> Admin
                </span>
              )}
            </div>
            <div className="text-xs text-slate-500 mt-1">Role: {user?.role}</div>
          </div>
        </div>
      </div>

      <div className="card divide-y divide-slate-100">
        <Row
          icon={UserIcon}
          label="Full name"
          value={user?.full_name || '—'}
          hint="Edit coming soon"
        />
        <Row icon={ShieldCheck} label="Role" value={user?.role || '—'} />
      </div>

      <button onClick={handleLogout} className="btn btn-danger btn-lg w-full sm:w-auto">
        <LogOut className="h-4 w-4" /> Sign out
      </button>
    </div>
  );
}

function Row({ icon: Icon, label, value, hint }: any) {
  return (
    <div className="flex items-center gap-4 p-5">
      <div className="w-10 h-10 rounded-lg bg-slate-100 grid place-items-center">
        <Icon className="h-4 w-4 text-slate-500" />
      </div>
      <div className="flex-1">
        <div className="text-xs font-bold text-slate-500 uppercase tracking-wider">{label}</div>
        <div className="text-sm text-slate-900 font-medium mt-0.5">{value}</div>
      </div>
      {hint && <div className="text-xs text-slate-400">{hint}</div>}
    </div>
  );
}
